import "@/cadence.css";
import { Head } from "vite-react-ssg";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import MobileApps from "@/components/landing/MobileApps";
import Practices from "@/components/landing/Practices";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import TrackSection from "@/components/analytics/TrackSection";

// Ordre des sections = funnel de scroll (section_viewed.order) pour PostHog.
const SECTIONS = [
  { name: "hero", Component: Hero },
  { name: "features", Component: Features },
  { name: "mobile_apps", Component: MobileApps },
  { name: "practices", Component: Practices },
  { name: "pricing", Component: Pricing },
  { name: "faq", Component: FAQ },
  { name: "contact", Component: Contact },
] as const;

const Index = () => {
  return (
    <>
    <Head>
      <title>CoachOS — Logiciel de gestion pour coach sportif et coach personnel</title>
      <meta name="description" content="CoachOS est le logiciel tout-en-un pour coach sportif : suivi clients centralisé, programmes d'entraînement, relances automatiques et apps mobiles iOS & Android. Sans engagement." />
      <link rel="canonical" href="https://www.coach-os.eu/" />
      <meta property="og:title" content="CoachOS — Logiciel de gestion pour coach sportif et coach personnel" />
      <meta property="og:description" content="Gérez vos clients, créez vos programmes et automatisez vos relances. Webapp + apps iOS & Android, pensées pour les coachs. Sans engagement." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.coach-os.eu/og-image.png" />
      <meta property="og:url" content="https://www.coach-os.eu/" />
    </Head>
    <div className="landing-page min-h-screen bg-background">
      <a href="#main-content" className="skip-link">Aller au contenu</a>
      <Navbar />
      <main id="main-content" tabIndex={-1}>
        {SECTIONS.map(({ name, Component }, i) => (
          <TrackSection key={name} name={name} order={i}>
            <Component />
          </TrackSection>
        ))}
      </main>
      <Footer />
    </div>
  </>
  );
};

export default Index;
